import React, { useEffect } from 'react'
import './Home.css'
import { useNavigate } from 'react-router-dom'
import { useContext } from 'react'
import { navigatorOpenContext } from '../../appContext'

function Home() {
    const { setNavigatorOpen } = useContext(navigatorOpenContext)

    useEffect(() => {
        setNavigatorOpen(true)
    }, [setNavigatorOpen])

    const Navigate = useNavigate()
    return (
        <div className="home">
            <div className="container">
                <h1>Muhammed habeeb kv</h1>
                <p>I started developing various technical skill after completing 12th grade. I have gained the experience and confidence to contribute my talents to the industry!</p>

                <nav>
                    <ul>
                        <li onClick={() => Navigate('/')}>
                            Home
                            <div className='active'></div>
                        </li>
                        <li onClick={() => Navigate('/project')}>Project
                            <div className='nav-line'></div>
                        </li>
                        <li onClick={() => Navigate('/about')}>About
                            <div className='nav-line'></div>
                        </li>
                    </ul>
                </nav>
                <div>
                    <a href="https://www.linkedin.com/in/muhammedhabeebkv">
                        <i className="fa fa-linkedin" aria-hidden="true"></i>
                    </a>
                    <a href="https://www.instagram.com/h4b33b_/">
                    <i className="fa fa-instagram" aria-hidden="true"></i>
                    </a>
                    <a href="https://twitter.com/cyb3rk1n5">
                        <i className="fa fa-twitter" aria-hidden="true"></i>
                    </a>

                </div>
            </div>
        </div>
    )
}

export default Home
